import $ from 'jquery';

$.fn.findWithSelf = function (...args: any) {
    // @ts-ignore
    return this.pushStack(this.find(...args).add(this.filter(...args)));
};
